import React, { ReactElement } from 'react';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { useBreadcrumb } from './BreadcrumbContext';

// Truncate long labels (use ellipsis character: …)
const truncateLabel = (label: string, maxLength: number = 15): string => {
  if (label.length <= maxLength + 1) return label;
  return `${label.substring(0, maxLength)}…`;
};

const BreadcrumbsNav: React.FC = () => {
  const location = useLocation();
  const { overrideLabel } = useBreadcrumb();
  const pathnames = location.pathname.split('/').filter((x) => x);

  const breadcrumbs: ReactElement[] = [
    <Link key="/" component={RouterLink} underline="hover" to="/" color="inherit">
      Home
    </Link>,
  ];

  pathnames.forEach((value, index) => {
    const to = `/${pathnames.slice(0, index + 1).join('/')}`;
    const isLast = index === pathnames.length - 1;

    if (isLast) {
      if (overrideLabel) {
        breadcrumbs.push(
          <Typography key={to} color="inherit">
            {truncateLabel(overrideLabel)}
          </Typography>
        );
      } else if (/^\d+$/.test(value)) {
        return;
      } else {
        breadcrumbs.push(
          <Typography key={to} color="inherit">
            {value.charAt(0).toUpperCase() + value.slice(1)}
          </Typography>
        );
      }
    } else {
      breadcrumbs.push(
        <Link key={to} component={RouterLink} underline="hover" to={to} color="inherit">
          {value.charAt(0).toUpperCase() + value.slice(1)}
        </Link>
      );
    }
  });

  return (
    <Breadcrumbs
      aria-label="breadcrumb"
      separator={<span style={{ color: 'inherit', margin: '0 -4px' }}>|</span>}
      sx={{ color: 'inherit' }}
    >
      {breadcrumbs}
    </Breadcrumbs>
  );
};

export default BreadcrumbsNav;